import * as React from 'react';

export const checkIconBig = (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="20" height="20" rx="10" fill="currentColor" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.73202 12.8386L15.9245 6.64614L14.8638 5.58548L8.67136 11.778L5.6413 8.74791L4.58064 9.80857L7.6107 12.8386L7.61062 12.8387L8.67128 13.8994L8.67136 13.8993L8.67163 13.8996L9.73229 12.8389L9.73202 12.8386Z"
			fill="white"
		/>
	</svg>
);

export const infoIcon = (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.666992 8.99996C0.666992 4.39996 4.40033 0.666626 9.00033 0.666626C13.6003 0.666626 17.3337 4.39996 17.3337 8.99996C17.3337 13.6 13.6003 17.3333 9.00033 17.3333C4.40033 17.3333 0.666992 13.6 0.666992 8.99996ZM9.83366 8.16663V13.1666H8.16699V8.16663H9.83366ZM9.00031 15.6666C5.32532 15.6666 2.33365 12.675 2.33365 8.99996C2.33365 5.32496 5.32532 2.33329 9.00031 2.33329C12.6753 2.33329 15.667 5.32496 15.667 8.99996C15.667 12.675 12.6753 15.6666 9.00031 15.6666ZM9.83366 4.83329V6.49996H8.16699V4.83329H9.83366Z"
			fill="#9A9A9A"
		/>
	</svg>
);

export const arrowIcon = (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
			fill="#808080"
		/>
	</svg>
);
